import * as React from 'react';
import assign = require('object-assign');
import translate from '../../../../locale/translate';

import ISettings from './ISettings';
import { IInputChangeEventHandler } from '../../../../interfaces';

import { formatDate } from '../../util/StringUtil';

interface IProps {
    settings: ISettings,
    handleChange: IInputChangeEventHandler,
}

const FORMATS = [
    'MMMM YYYY',
    'L',
    'LL',
    'dddd, LL'
];

export default class Editor extends React.Component<IProps, void> {
    static propTypes = {
        settings: React.PropTypes.object.isRequired,
        handleChange: React.PropTypes.func.isRequired
    };

    handleChange(evt: React.ChangeEvent<HTMLTextAreaElement>) {
        this.props.handleChange(evt.target.name, evt.target.value);
    }

    handleSelect(evt: React.ChangeEvent<HTMLSelectElement>) {
        this.props.handleChange(evt.target.name, evt.target.value);
    }

    render() {
        const { handleChange, settings } = this.props;
        const now = new Date();

        return (
            <div>
                <div className="form-group">
                    <label>{translate.gettext("Title")}</label>
                    <textarea name="title" className="form-control" value={settings.title} onChange={this.handleChange.bind(this)} />
                </div>
                <div className="form-group">
                    <label>{translate.gettext("Date format")}</label>
                    <select name="dateFormat" className="form-control" value={settings.dateFormat} onChange={this.handleSelect.bind(this)} >
                        {FORMATS.map(format => {
                            return <option key={format} value={format}>{formatDate(now, format)}</option>
                        })}
                    </select>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/basic/title/Editor.tsx